var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExportIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.64691 3.09088C9.93135 3.37532 9.93135 3.83648 9.64691 4.12092C9.36247 4.40537 8.9013 4.40536 8.61686 4.12092L7.2845 2.78856V10.9445C7.2845 11.3468 6.95835 11.6729 6.55603 11.6729C6.15371 11.6729 5.82757 11.3468 5.82757 10.9445V2.78929L4.49594 4.12092C4.21147 4.4054 3.75028 4.40548 3.46571 4.12111C3.18099 3.8366 3.18091 3.37512 3.46552 3.09051L6.55603 0L9.64691 3.09088Z",
    fill: "url(#paint0_linear_2975_334)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.45693 14.5424C2.35236 14.5424 1.45693 13.6469 1.45693 12.5424V8.09024C1.45693 7.63045 1.82967 7.25771 2.28946 7.25771H3.64232C4.04464 7.25771 4.37079 6.93157 4.37079 6.52925C4.37079 6.12693 4.04464 5.80078 3.64232 5.80078H1.2488C0.559105 5.80078 0 6.35989 0 7.04958V13.9993C0 15.1039 0.895431 15.9993 2 15.9993H11.1124C12.2169 15.9993 13.1124 15.1039 13.1124 13.9993V7.04958C13.1124 6.35988 12.5533 5.80078 11.8636 5.80078H9.47004C9.06772 5.80078 8.74158 6.12693 8.74158 6.52925C8.74158 6.93157 9.06772 7.25771 9.47004 7.25771H10.8229C11.2827 7.25771 11.6554 7.63045 11.6554 8.09024V12.5424C11.6554 13.6469 10.76 14.5424 9.65544 14.5424H3.45693Z",
    fill: "url(#paint1_linear_2975_334)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2975_334",
    x1: 2.95013,
    y1: 0,
    x2: 4.93699,
    y2: 12.6372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#103C67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E4D6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2975_334",
    x1: 0,
    y1: 5.80078,
    x2: 0.849918,
    y2: 17.0505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#103C67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E4D6B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/exportIcon.0aee1a69.svg";
export { ForwardRef as ReactComponent };